import { getPaymentCalculatorDiscountPromotion } from "../../../helpers/tools";

export function latinAmericaEuropeDiscountsElicos(
  data,
  paymentType,
  courses,
  specialCases
) {
  // reset
  for (const course of courses) {
    course.discountsApplied = [];
    course.finalTuition = course.tuition;
  }

  // Promo: pay 20 weeks, get 4 weeks free (repeatable)
  const REQUIRED_WEEKS = 24;
  const EXTRA_FREE_WEEKS = 4;

  // Determine which stream the student picked (day OR evening)
  
  const eligibleCourses = courses?.filter((c) =>
    ["day", "evening"].includes(c?.coursePricing?.course?.type)
  );

  if (!eligibleCourses?.length) {
    console.debug("No eligible courses for 20+4 promo:", courses);
    return;
  }

/*
  // If student somehow has both types, pick the type that actually exists first.
  // (In your case they won't select both, so this is just defensive.)
  const selectedType = eligibleCourses[0]?.coursePricing?.course?.type;

  const selectedTypeCourses = eligibleCourses.filter(
    (c) => c?.coursePricing?.course?.type === selectedType
  );

*/
  const totalWeeks = eligibleCourses.reduce(
    (sum, c) => sum + (parseInt(c?.duration, 10) || 0),
    0
  );

  const bundles = Math.floor(totalWeeks / REQUIRED_WEEKS);
  const freeWeeks = bundles * EXTRA_FREE_WEEKS;

console.log("DISCOUNT CHECK:", {
  totalWeeks,
  bundles,
  freeWeeks,
  courseType: eligibleCourses[0]?.coursePricing?.course?.type,
  weeklyFee: eligibleCourses[0]?.coursePricing?.weekly_tuition_fee,
  tuition: eligibleCourses[0]?.tuition,
  finalTuition: eligibleCourses[0]?.finalTuition,
});

  if (bundles > 0) {
    // apply discount to the first course of that type (usually the only one)
    //const targetCourse = selectedTypeCourses[0];
    const targetCourse = eligibleCourses[eligibleCourses.length - 1];
    const weeklyFee = parseFloat(targetCourse?.coursePricing?.weekly_tuition_fee) || 0;
    const discount = weeklyFee * freeWeeks;
    targetCourse.finalTuition -= discount;
    
    targetCourse.discountsApplied.push({
      code: "20_plus_4",
      description: `Pay ${REQUIRED_WEEKS} weeks get ${EXTRA_FREE_WEEKS} free (x${bundles})`,
      freeWeeks,
      amount: 0,
    });

    console.log("20+4 discount applied to:", targetCourse);
  }

  console.log("Courses after discounts were applied:", courses);

  // Old promo (21+3) kept for reference but disabled:
  /*
  const discount24Week = getPaymentCalculatorDiscountPromotion(
    data,
    "24_weeks_discount"
  )?.parameters;
  */
}

